export default {
  LANDING_COMPANY: {
    HEADER: {
      YOU_ARE_USER: '¿Buscas trabajo?',
      DOWNLOAD_APP: 'Bajar app',
      ACCESS: 'Iniciar sesión',
      REGISTER: 'Registrarte',
    },
    META: {
      TITLE: '<b>¡Encuentra el mejor talento para&nbsp;tu&nbsp;empresa en wokap!</b>',
      TEXT: 'El software de reclutamiento que&nbsp;está&nbsp;revolucionando la forma&nbsp;de&nbsp;contratar.',
      TEXT2: 'Una nueva era ha comenzado...',
      ACCESS: 'Acceder a wokap',
      TAGLINE: 'wokap es el software de reclutamiento<br class="block sm:hidden"> que está revolucionando la forma de contratar.',
    },
    COMPANIES: { TEXT: 'Empresas que han logrado resultados&nbsp;increíbles con wokap:' },
    CONTACT: {
      TITLE: 'Solicítanos información',
      TEXT: 'Información empresa',
      FORM: {
        NAME: 'Nombre de contacto',
        COMPANY_NAME: 'Nombre comercial',
        PHONE: 'Teléfono',
        EMAIL: 'Correo electrónico',
        SUBMIT: 'Enviar',
        TERMS: 'Al continuar acepto las condiciones generales y la política de privacidad de wokap',
        TOAST: {
          SUCCESS: 'Muchas gracias por contactar con nosotros, en breve nos pondremos en contacto contigo.',
          TITLE: 'Contacto enviado correctamente',
        },
        ERRORS: {
          SUBMIT_ERROR: 'Ha habido un error al enviar el formulario, por favor inténtelo más adelante.',
          FORM_ERROR: 'Hay errores en el formulario, por favor revise todos los campos',
        },
      },
    },
    FOOTER: {
      CONTACT: 'Contacto',
      CONTACT_MESSAGE: '¡Hola! Me interesa saber más sobre wokap. ¿Podrías darme más información?',
      COPYRIGHT: 'Todos los derechos reservados © wokap',
      PRIVACY: 'Política de privacidad',
      LEGAL: 'Aviso legal',
    },
  },
} as const;
